import React from 'react';
import { Path, Svg, type SvgProps } from 'react-native-svg';
import { useUnistyles } from 'react-native-unistyles';

import type { AppColors } from '@squire/ui';

export interface StripeIconProps extends SvgProps {
  size?: number;
  color?: keyof AppColors;
}

export const StripeIcon: React.FC<StripeIconProps> = ({
  size = 64,
  color = 'iconPrimary',
  ...props
}) => {
  const { theme: colors } = useUnistyles();

  return (
    <Svg viewBox="0 0 512 512" width={size} height={size} {...props}>
      <Path
        d="M223.6,166.9c0-19.6,16.3-27.2,42.5-27.2c38.1,0,86.6,11.7,124.7,32.2v-118C349.3,37.3,307.8,31,266.2,31 C164.6,31,96.8,84.1,96.8,172.8c0,138.8,190.5,116.3,190.5,176.1c0,23.2-20.1,30.7-48.1,30.7c-41.5,0-95.1-17.1-137.2-40v112.9 c43.3,18.7,89.9,28.4,137.1,28.5c104.2,0,176-44.8,176-135C415.2,196.5,223.6,223.3,223.6,166.9L223.6,166.9z"
        fill={colors[color]}
      />
    </Svg>
  );
};

StripeIcon.displayName = 'StripeIcon';
